import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  SendWhatsAppInboxMessageBodySchema,
  type SendWhatsAppInboxMessageBody,
} from '@zrsystem/contracts';

import { sendWhatsAppInboxMessage } from '@/features/notification/api/whatsapp-inbox.api.js';
import { notificationQueryKeys } from '@/features/notification/query-keys.js';

export function parseSendWhatsAppInboxMessageBody(
  body: SendWhatsAppInboxMessageBody,
): SendWhatsAppInboxMessageBody {
  return SendWhatsAppInboxMessageBodySchema.parse(body);
}

export function useSendWhatsAppInboxMessage(placeId: string, chatId: string | null) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: SendWhatsAppInboxMessageBody) => {
      if (chatId === null) {
        throw new Error('chatId is required');
      }
      const payload = parseSendWhatsAppInboxMessageBody(body);
      return sendWhatsAppInboxMessage(placeId, chatId, payload);
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: notificationQueryKeys.whatsappInboxChats(placeId),
        }),
        chatId !== null
          ? queryClient.invalidateQueries({
              queryKey: notificationQueryKeys.whatsappInboxMessages(placeId, chatId),
            })
          : Promise.resolve(),
      ]);
    },
  });
}
